import { render, staticRenderFns } from "./candidateNotes.vue?vue&type=template&id=19a12a1c&scoped=true&"
import script from "./candidateNotes.vue?vue&type=script&lang=js&"
export * from "./candidateNotes.vue?vue&type=script&lang=js&"
import style0 from "./candidateNotes.vue?vue&type=style&index=0&id=19a12a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a12a1c",
  null
  
)

export default component.exports